import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const Container = styled.div `
  width: 100%;

  .title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid ${Color.greySeparator};
    border-bottom: 1px solid ${Color.greySeparator};
    margin-top: 5px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-top: 1px solid ${ColorDark.greySeparator};
      border-bottom: 1px solid ${ColorDark.greySeparator};
      }

    }
    ${breakpoints.phone} {
      flex-direction: column;
      align-items: flex-start;
    }
    ${breakpoints.tablet} {
      flex-direction: column;
      align-items: flex-start;
    }

    &.home {
      border-top: none;
      margin-top: -10px;
      padding-bottom: 10px;
    }

    .home {
      ${Font.clarinVarSub2Regular}
      font-size: 36px;
      line-height: 28px;
      color: ${Color.grey};
      padding: 15px 0px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        font-size: 26px;
      }
    }

    .api-provided{
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      ${breakpoints.phone} {
        [data-theme='dark'] & {
        margin-top: 25px
        }
      }
    }

    .provided {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      align-items: flex-end;
      margin-top: 15px;
      padding-right: 20px;
      
      ${breakpoints.phone} {
        flex-direction: row;
        align-items: center;
        gap: 10px;
        margin-top: -5px;
        margin-left: 5px;
        margin-bottom: 15px;
      }

      ${breakpoints.tablet} {
        flex-direction: row;
        align-items: center;
        gap: 10px;
        margin-top: 25px;
        margin-left: 5px;
        margin-bottom: 15px;
      }

      span {
        ${Font.sansRegular}
        font-size: 9px;
        line-height: 15px;
        color: ${Color.grey};
        text-align: right;
        margin-bottom: 5px;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.textLight};
          }
        }
      }
      img {
        ${breakpoints.phone} {
          height: 30px;
        }
      }
    }

    .detail {
      ${Font.sansBold}
      font-size: 20px;
      line-height: 19px;
      color: ${Color.black000};
      padding: 15px 0px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.textLight};
        }
      }
    }
  }

  .dolar-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    ${breakpoints.phone} {
      flex-direction: row;
    }

    .card {
      width: 33.3%;
      padding: 15px 0px;
      border-bottom: 1px solid ${Color.greySeparator};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        border-bottom: 1px solid ${ColorDark.greySeparator};
        }
      }
      ${breakpoints.phone} {
        width: 100%;
      }

      &:nth-last-child(-n + 3) {
        border-bottom: none;
        ${breakpoints.phone} {
          border-bottom: 1px solid ${Color.greySeparator};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            border-bottom: 1px solid ${ColorDark.greySeparator};
            }
          }
        }
      }
      &:nth-last-child(3n - 2) {
        .card-content {
          border-right: none;
        }
      }
      .card-content {
        border-right: 1px solid ${Color.greySeparator};
        height: 310px;
        gap: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        ${breakpoints.phone} {
          border-right: none;
          height: 250px;
        }

        h2 {
          ${Font.sansBold}
          font-size: 21px;
          line-height: 24px;
          color: ${Color.black000};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color: ${ColorDark.textLight};
            }
          }
        }

        .currency-values {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 280px;
       
          @media (min-width: 976px) and (max-width: 1350px) {
            width: 190px;
          }
         

          p {
            ${Font.sansRegular}
            font-size: 12px;
            line-height: 20px;
            color: ${Color.grey};
            letter-spacing: -0.12px;
            margin-bottom: 12px;
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.grey};
              }
            }
          }
          span {
            ${Font.sansLight}
            font-size: 36px;
            line-height: 24px;
            color: ${Color.grey};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.textLight};
              }
            }
            @media (min-width: 976px) and (max-width: 1350px) {
              font-size: 26px;
            }
           
          }

          .selling,
          .buying {
            display: flex;
            align-items: center;
            flex-direction: column;
          }

          .separator {
            border-left: 1px solid ${Color.greySeparator};
            height: 55px;
          }
        }

        .button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 90px;
          height: 39px;
          ${Font.sansRegular}
          font-size: 13px;
          line-height: 20px;
          color: ${Color.black000};
          background-color: ${Color.weatherGray};
          border-radius: 50px;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            background-color: ${ColorDark.darkGrey};
            color: ${ColorDark.textLight};
            }
          }

          :hover {
            background-color: ${Color.greySeparator};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              background-color: ${ColorDark.grey};
              }
            }
          }
        }
      }
    }
  }

  .last-value {
    margin-top: 15px;
    margin-bottom: 20px;
    ${Font.sansRegular}
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color: ${Color.greyCurrency};
    @media (min-width: 976px) and (max-width: 1350px) {
      line-height: 18px;
      width: 90%;
    }
  }
`;